<div class="container mt-4">
    <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-8">
            <div class="card">
                <div class="card-body">
                    <div class="mb-2 text-center">
                        <i class="fa-solid fa-folder-closed mt-2 mb-4"></i>
                        <div class="heading-md mb-4">This claim can't be acted upon at this time</div>
                        <p class="caption-lg mb-5">
                            This may be because the claim resolution is currently in process, has already been resolved or is not in a status that allows responses.
                        </p>
                        <p>
                            If you believe this is an error or if you have any questions, please contact us at:
                            <a class="no-wrap" href="mailto:trp&#64;dewarinsurance.com">trp&#64;dewarinsurance.com</a><br />
                            or call&nbsp;<a class="no-wrap" href="tel:6177741555">617-774-1555.</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
